import React, { useEffect, useState } from 'react';
import { Search, Calendar, Users, ChevronDown, ChevronRight, CheckCircle2, Clock, Wrench, Eye, ArrowUp, ArrowDown, Award, X } from 'lucide-react';
import { getKPITeknisi, getKPIAkhir } from '../api';

const BULAN_INDONESIA = [
  '', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
];

function TeknisiRow({ d, i, expanded, onToggle }) {
  const pct = d.persentase || 0;
  const color = pct >= 80 ? '#2dce89' : pct >= 50 ? '#f59e0b' : '#f5365c';

  return (
    <>
      <tr
        onClick={onToggle}
        style={{
          borderBottom: '1px solid var(--gray-50)',
          background: expanded ? '#f0f4ff' : i % 2 === 0 ? '#fff' : '#fafafa',
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.background = expanded ? '#e8edf8' : '#f3f4f6'}
        onMouseLeave={e => e.currentTarget.style.background = expanded ? '#f0f4ff' : i % 2 === 0 ? '#fff' : '#fafafa'}
      >
        <td style={{ padding: '12px 14px', color: 'var(--gray-400)', fontWeight: 600, width: 30 }}>
          {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </td>
        <td style={{ padding: '12px 14px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 34, height: 34, borderRadius: 10,
              background: pct >= 80 ? 'linear-gradient(135deg, #2dce89, #1aae6f)'
                       : pct >= 50 ? 'linear-gradient(135deg, #f59e0b, #d97706)'
                       : 'linear-gradient(135deg, #667eea, #764ba2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: '0.75rem', fontWeight: 700, flexShrink: 0,
            }}>
              {d.nama?.charAt(0) || '?'}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: '0.88rem' }}>{d.nama || '-'}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--gray-400)' }}>{d.nik || ''} · {d.jabatan || ''}</div>
            </div>
            <button
              onClick={e => { e.stopPropagation(); onToggle(); }}
              title={expanded ? 'Tutup detail' : 'Lihat detail kendaraan'}
              style={{
                background: expanded ? '#e8edf8' : 'transparent',
                border: expanded ? '1px solid #c7d2fe' : '1px solid transparent',
                borderRadius: 8, padding: '6px 8px', cursor: 'pointer',
                color: expanded ? '#4f46e5' : 'var(--gray-400)',
                display: 'flex', alignItems: 'center', gap: 4,
                fontSize: '0.72rem', fontWeight: 500, flexShrink: 0,
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#eef2ff'; e.currentTarget.style.borderColor = '#c7d2fe'; e.currentTarget.style.color = '#4f46e5'; }}
              onMouseLeave={e => { e.currentTarget.style.background = expanded ? '#e8edf8' : 'transparent'; e.currentTarget.style.borderColor = expanded ? '#c7d2fe' : 'transparent'; e.currentTarget.style.color = expanded ? '#4f46e5' : 'var(--gray-400)'; }}
            >
              <Eye size={15} />
              {expanded ? 'Tutup' : 'Detail'}
            </button>
          </div>
        </td>
        <td style={{ padding: '12px 14px', textAlign: 'center', fontWeight: 700, fontSize: '0.95rem' }}>
          {d.total_kendaraan || 0}
        </td>
        <td style={{ padding: '12px 14px', textAlign: 'center', fontWeight: 700, fontSize: '0.95rem', color: '#2dce89' }}>
          {d.pm_selesai || 0}
        </td>
        <td style={{ padding: '12px 14px', textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
            <div style={{
              flex: 1, minWidth: 100, height: 8, borderRadius: 4,
              background: '#e5e7eb', overflow: 'hidden',
            }}>
              <div style={{
                width: `${Math.min(pct, 100)}%`, height: '100%',
                background: color, borderRadius: 4,
                transition: 'width 0.5s ease',
              }} />
            </div>
            <span style={{
              padding: '2px 10px', borderRadius: 4,
              background: pct >= 80 ? '#d4edda' : pct >= 50 ? '#fff3cd' : '#f8d7da',
              color: pct >= 80 ? '#155724' : pct >= 50 ? '#856404' : '#721c24',
              fontWeight: 700, fontSize: '0.85rem', minWidth: 48, textAlign: 'center',
            }}>
              {Math.round(pct)}%
            </span>
          </div>
        </td>
      </tr>
      {expanded && (
        <tr>
          <td colSpan={5} style={{ padding: 0, background: '#f8faff' }}>
            <div style={{
              padding: '12px 14px 16px 48px',
              borderBottom: '1px solid var(--gray-100)',
            }}>
              {/* Vehicles - Completed */}
              <div style={{ marginBottom: 12 }}>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  marginBottom: 8, fontSize: '0.78rem', fontWeight: 600,
                  color: '#155724',
                }}>
                  <CheckCircle2 size={14} />
                  Selesai PM ({d.vehicles_selesai?.length || 0} kendaraan)
                </div>
                {(!d.vehicles_selesai || d.vehicles_selesai.length === 0) ? (
                  <div style={{ fontSize: '0.75rem', color: 'var(--gray-400)', paddingLeft: 20 }}>
                    Belum ada kendaraan yang selesai PM
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, paddingLeft: 20 }}>
                    {d.vehicles_selesai.map((v, vi) => (
                      <div key={vi} style={{
                        display: 'flex', alignItems: 'center', gap: 6,
                        padding: '5px 10px', borderRadius: 8,
                        background: '#d4edda', border: '1px solid #c3e6cb',
                        fontSize: '0.75rem',
                      }}>
                        <CheckCircle2 size={12} color="#155724" />
                        <span style={{ fontWeight: 600, color: '#155724' }}>{v.no_body}</span>
                        <span style={{ color: '#155724', opacity: 0.7 }}>{v.no_polisi}</span>
                        {v.pm_id_code && (
                          <span style={{
                            background: '#155724', color: '#fff',
                            padding: '1px 5px', borderRadius: 3,
                            fontSize: '0.65rem', fontWeight: 600,
                          }}>
                            {v.pm_id_code}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Vehicles - Not Yet */}
              <div>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  marginBottom: 8, fontSize: '0.78rem', fontWeight: 600,
                  color: '#856404',
                }}>
                  <Clock size={14} />
                  Belum Selesai PM ({d.vehicles_belum?.length || 0} kendaraan)
                </div>
                {(!d.vehicles_belum || d.vehicles_belum.length === 0) ? (
                  <div style={{ fontSize: '0.75rem', color: 'var(--gray-400)', paddingLeft: 20 }}>
                    Semua kendaraan sudah selesai PM ✓
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, paddingLeft: 20 }}>
                    {d.vehicles_belum.map((v, vi) => (
                      <div key={vi} style={{
                        display: 'flex', alignItems: 'center', gap: 6,
                        padding: '5px 10px', borderRadius: 8,
                        background: '#fff3cd', border: '1px solid #ffeeba',
                        fontSize: '0.75rem',
                      }}>
                        <Clock size={12} color="#856404" />
                        <span style={{ fontWeight: 600, color: '#856404' }}>{v.no_body}</span>
                        <span style={{ color: '#856404', opacity: 0.7 }}>{v.no_polisi}</span>
                        {v.brand && <span style={{ color: 'var(--gray-500)', fontSize: '0.65rem' }}>{v.brand}</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default function KPI() {
  const [activeTab, setActiveTab] = useState('pm'); // 'pm' or 'akhir'
  const [data, setData] = useState([]);
  const [akhirData, setAkhirData] = useState([]);
  const [summary, setSummary] = useState({ total_teknisi: 0, bulan: '' });
  const [loading, setLoading] = useState(true);
  const now = new Date();
  const defaultMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const [bulan, setBulan] = useState(defaultMonth);
  const [tglAwal, setTglAwal] = useState(() => {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
  });
  const [tglAkhir, setTglAkhir] = useState(() => {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate().toString().padStart(2, '0')}`;
  });
  const [search, setSearch] = useState('');
  const [searchAkhir, setSearchAkhir] = useState('');
  const [expandedRows, setExpandedRows] = useState({});
  const [detailModal, setDetailModal] = useState(null); // { teknisi, tab: 'jasa'|'absensi' }

  const toggleRow = (idx) => {
    setExpandedRows(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const handleBulanChange = (b) => {
    setBulan(b);
    const [year, month] = b.split('-');
    const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
    setTglAwal(`${b}-01`);
    setTglAkhir(`${b}-${String(lastDay).padStart(2, '0')}`);
  };



  const loadPM = (awal, akhir) => {
    setLoading(true);
    getKPITeknisi({ tgl_awal: awal, tgl_akhir: akhir })
      .then(res => {
        setData(res.data?.data || []);
        setSummary({ total_teknisi: res.data?.total_teknisi || 0, bulan: res.data?.bulan || '' });
        setExpandedRows({});
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  };

  const loadAkhir = (awal, akhir) => {
    setLoading(true);
    getKPIAkhir({ tgl_awal: awal, tgl_akhir: akhir })
      .then(res => {
        setAkhirData(res.data?.data || []);
        setSummary({ total_teknisi: res.data?.total_teknisi || 0, bulan: res.data?.periode || '' });
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (activeTab === 'pm') {
      loadPM(tglAwal, tglAkhir);
    } else {
      loadAkhir(tglAwal, tglAkhir);
    }
  }, [tglAwal, tglAkhir, activeTab]);

  // Sort by Persentase descending (PM tab)
  const sortedData = [...data].sort((a, b) => (b.persentase || 0) - (a.persentase || 0));
  const filtered = search
    ? sortedData.filter(d => d.nama.toLowerCase().includes(search.toLowerCase()))
    : sortedData;

  // Sort by TotalPoint descending (Akhir tab)
  const sortedAkhir = [...akhirData].sort((a, b) => (b.total_point || 0) - (a.total_point || 0));
  const filteredAkhir = searchAkhir
    ? sortedAkhir.filter(d => d.nama.toLowerCase().includes(searchAkhir.toLowerCase()))
    : sortedAkhir;

  const totalKendaraan = sortedData.reduce((s, d) => s + (d.total_kendaraan || 0), 0);
  const totalPMSelesai = sortedData.reduce((s, d) => s + (d.pm_selesai || 0), 0);
  const overallPct = totalKendaraan > 0 ? Math.round((totalPMSelesai / totalKendaraan) * 100) : 0;

  // Akhir summary
  const totalPointJasa = sortedAkhir.reduce((s, d) => s + (d.point_jasa || 0), 0);
  const totalPointAbsensi = sortedAkhir.reduce((s, d) => s + (d.point_absensi || 0), 0);
  const totalPointAll = sortedAkhir.reduce((s, d) => s + (d.total_point || 0), 0);

  const dateRangeLabel = tglAwal && tglAkhir
    ? `${tglAwal.split('-')[2]} ${BULAN_INDONESIA[parseInt(tglAwal.split('-')[1])]} ${tglAwal.split('-')[0]} — ${tglAkhir.split('-')[2]} ${BULAN_INDONESIA[parseInt(tglAkhir.split('-')[1])]} ${tglAkhir.split('-')[0]}`
    : '';

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-header-row">
          <div>
            <h2>KPI Teknisi</h2>
            <p className="page-desc">Monitoring kinerja tim teknisi · {dateRangeLabel}</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* Export CSV hidden */}
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 16, borderBottom: '2px solid var(--gray-100)' }}>
        <button
          onClick={() => setActiveTab('pm')}
          style={{
            padding: '10px 24px', border: 'none', cursor: 'pointer',
            background: activeTab === 'pm' ? '#fff' : 'transparent',
            fontWeight: activeTab === 'pm' ? 700 : 500,
            color: activeTab === 'pm' ? '#4f46e5' : 'var(--gray-500)',
            borderBottom: activeTab === 'pm' ? '2px solid #4f46e5' : '2px solid transparent',
            marginBottom: -2, fontSize: '0.85rem', transition: 'all 0.15s',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
          onMouseEnter={e => { if (activeTab !== 'pm') { e.currentTarget.style.color = '#4f46e5'; e.currentTarget.style.background = '#f8f9ff'; } }}
          onMouseLeave={e => { if (activeTab !== 'pm') { e.currentTarget.style.color = 'var(--gray-500)'; e.currentTarget.style.background = 'transparent'; } }}
        >
          <Wrench size={15} />
          KPI PM
        </button>
        <button
          onClick={() => setActiveTab('akhir')}
          style={{
            padding: '10px 24px', border: 'none', cursor: 'pointer',
            background: activeTab === 'akhir' ? '#fff' : 'transparent',
            fontWeight: activeTab === 'akhir' ? 700 : 500,
            color: activeTab === 'akhir' ? '#4f46e5' : 'var(--gray-500)',
            borderBottom: activeTab === 'akhir' ? '2px solid #4f46e5' : '2px solid transparent',
            marginBottom: -2, fontSize: '0.85rem', transition: 'all 0.15s',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
          onMouseEnter={e => { if (activeTab !== 'akhir') { e.currentTarget.style.color = '#4f46e5'; e.currentTarget.style.background = '#f8f9ff'; } }}
          onMouseLeave={e => { if (activeTab !== 'akhir') { e.currentTarget.style.color = 'var(--gray-500)'; e.currentTarget.style.background = 'transparent'; } }}
        >
          <Award size={15} />
          KPI Akhir
        </button>
      </div>

      {/* Filter Periode — below tabs, consistent for both KPI PM & KPI Akhir */}
      <div style={{
        background: '#f8f9ff', border: '1px solid #e2e8f0', borderRadius: 12,
        padding: '14px 20px', marginBottom: 16,
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      }}>
        <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#4f46e5', display: 'flex', alignItems: 'center', gap: 6 }}>
          <Calendar size={16} />
          {activeTab === 'pm' ? 'Periode KPI PM' : 'Periode KPI Akhir'}
        </div>
        {activeTab === 'pm' && (
          <input
            type="month"
            value={bulan}
            onChange={e => handleBulanChange(e.target.value)}
            style={{
              padding: '7px 10px', border: '1px solid var(--gray-200)', borderRadius: 8,
              fontSize: '0.8rem', background: '#fff', maxWidth: 150,
            }}
          />
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          <span style={{ fontSize: '0.78rem', color: 'var(--gray-500)' }}>Dari:</span>
          <input
            type="date"
            value={tglAwal}
            onChange={e => { setTglAwal(e.target.value); setBulan(''); }}
            style={{
              padding: '7px 10px', border: '1px solid var(--gray-200)', borderRadius: 8,
              fontSize: '0.8rem', background: '#fff', maxWidth: 160,
            }}
          />
          <span style={{ color: 'var(--gray-400)', fontSize: '0.8rem' }}>s/d</span>
          <input
            type="date"
            value={tglAkhir}
            onChange={e => { setTglAkhir(e.target.value); setBulan(''); }}
            style={{
              padding: '7px 10px', border: '1px solid var(--gray-200)', borderRadius: 8,
              fontSize: '0.8rem', background: '#fff', maxWidth: 160,
            }}
          />
        </div>
        <button
          onClick={() => activeTab === 'pm' ? loadPM(tglAwal, tglAkhir) : loadAkhir(tglAwal, tglAkhir)}
          style={{
            padding: '7px 16px', borderRadius: 8, border: 'none',
            background: '#4f46e5', color: '#fff', fontSize: '0.8rem',
            fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4,
          }}
        >
          <Search size={14} />Tampilkan
        </button>
      </div>

      {/* Summary Cards - PM */}
      {activeTab === 'pm' ? (
        <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
          <div style={{
            background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              <Users size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />Total Teknisi
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{summary.total_teknisi}</div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #2dce89, #1aae6f)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              <Wrench size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />Total Penugasan
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{totalKendaraan}</div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #11cdef, #1171ef)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              Pencapaian PM
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{totalPMSelesai}</div>
          </div>
          <div style={{
            background: `linear-gradient(135deg, ${overallPct >= 80 ? '#2dce89' : overallPct >= 50 ? '#f59e0b' : '#f5365c'}, ${overallPct >= 80 ? '#1aae6f' : overallPct >= 50 ? '#d97706' : '#fb6340'})`,
            color: '#fff', borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              Rata-rata
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{overallPct}%</div>
          </div>
        </div>
      ) : (
        /* Summary Cards - KPI Akhir */
        <div style={{ display: 'flex', gap: 16, marginBottom: 16, flexWrap: 'wrap' }}>
          <div style={{
            background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              <Users size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />Total Teknisi
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{summary.total_teknisi}</div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #2dce89, #1aae6f)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              <Award size={14} style={{ marginRight: 6, verticalAlign: 'middle' }} />Total Point Jasa
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{totalPointJasa}</div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #11cdef, #1171ef)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              Total Point Absensi
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{totalPointAbsensi}</div>
          </div>
          <div style={{
            background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#fff',
            borderRadius: 12, padding: '14px 20px', minWidth: 160, flex: 1,
          }}>
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', opacity: 0.75, fontWeight: 600, marginBottom: 4 }}>
              Grand Total
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{totalPointAll}</div>
          </div>
        </div>
      )}

      {/* Table Content */}
      {activeTab === 'pm' ? (
        /* === KPI PM TABLE === */
        <div style={{
          background: '#fff', borderRadius: 14, border: '1px solid var(--gray-100)',
          overflow: 'hidden',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 20px', borderBottom: '1px solid var(--gray-100)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <h4 style={{ margin: 0, fontSize: '0.85rem', fontWeight: 700 }}>Detail KPI Teknisi</h4>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-400)', background: 'var(--gray-50)', padding: '2px 8px', borderRadius: 4 }}>
                {filtered.length} teknisi
              </span>
            </div>
            <div className="search-box" style={{ maxWidth: 200 }}>
              <Search size={14} />
              <input
                type="text"
                placeholder="Cari teknisi..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ fontSize: '0.78rem' }}
              />
            </div>
          </div>

          {loading ? (
            <div className="page-loading" style={{ padding: 40 }}>Memuat data...</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="table" style={{ fontSize: '0.85rem', width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8f9fa', borderBottom: '2px solid var(--gray-100)' }}>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: 'var(--gray-500)', width: 30 }}></th>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: 'var(--gray-500)' }}>Nama Teknisi</th>
                    <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)' }}>Penugasan</th>
                    <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)' }}>Pencapaian PM</th>
                    <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)' }}>Persentase</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 && (
                    <tr>
                      <td colSpan={5} style={{ padding: 30, textAlign: 'center', color: 'var(--gray-400)' }}>
                        Tidak ada data KPI untuk periode ini
                      </td>
                    </tr>
                  )}
                  {filtered.map((d, i) => (
                    <TeknisiRow
                      key={d.id || i}
                      d={d}
                      i={i}
                      expanded={!!expandedRows[i]}
                      onToggle={() => toggleRow(i)}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        /* === KPI AKHIR TABLE === */
        <div style={{
          background: '#fff', borderRadius: 14, border: '1px solid var(--gray-100)',
          overflow: 'hidden',
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 20px', borderBottom: '1px solid var(--gray-100)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <h4 style={{ margin: 0, fontSize: '0.85rem', fontWeight: 700 }}>KPI Akhir — Point Jasa & Absensi</h4>
              <span style={{ fontSize: '0.7rem', color: 'var(--gray-400)', background: 'var(--gray-50)', padding: '2px 8px', borderRadius: 4 }}>
                {filteredAkhir.length} teknisi
              </span>
            </div>
            <div className="search-box" style={{ maxWidth: 200 }}>
              <Search size={14} />
              <input
                type="text"
                placeholder="Cari teknisi..."
                value={searchAkhir}
                onChange={e => setSearchAkhir(e.target.value)}
                style={{ fontSize: '0.78rem' }}
              />
            </div>
          </div>

          {loading ? (
            <div className="page-loading" style={{ padding: 40 }}>Memuat data...</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="table" style={{ fontSize: '0.85rem', width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8f9fa', borderBottom: '2px solid var(--gray-100)' }}>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: 'var(--gray-500)' }}>Nama Teknisi</th>
                    <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                        <ArrowUp size={13} color="#2dce89" />
                        Point Jasa
                      </div>
                    </th>
                    <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                        <Clock size={13} />
                        Point Absensi
                      </div>
                    </th>
                    <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                        <Award size={13} color="#f59e0b" />
                        Total Point
                      </div>
                    </th>
                    <th style={{ padding: '10px 14px', textAlign: 'right', fontWeight: 600, color: 'var(--gray-500)' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAkhir.length === 0 && (
                    <tr>
                      <td colSpan={5} style={{ padding: 30, textAlign: 'center', color: 'var(--gray-400)' }}>
                        Tidak ada data KPI untuk periode ini
                      </td>
                    </tr>
                  )}
                  {filteredAkhir.map((d, i) => (
                    <tr key={d.id || i} style={{
                      borderBottom: '1px solid var(--gray-50)',
                      background: i % 2 === 0 ? '#fff' : '#fafafa',
                      transition: 'background 0.15s',
                    }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                      onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafafa'}
                    >
                      <td style={{ padding: '12px 14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div style={{
                            width: 34, height: 34, borderRadius: 10,
                            background: d.total_point > 0
                              ? 'linear-gradient(135deg, #2dce89, #1aae6f)'
                              : d.total_point === 0
                              ? 'linear-gradient(135deg, #f59e0b, #d97706)'
                              : 'linear-gradient(135deg, #f5365c, #fb6340)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: '#fff', fontSize: '0.75rem', fontWeight: 700, flexShrink: 0,
                          }}>
                            {d.nama?.charAt(0) || '?'}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: 600, fontSize: '0.88rem' }}>{d.nama || '-'}</div>
                            <div style={{ fontSize: '0.72rem', color: 'var(--gray-400)' }}>{d.nik || ''} · {d.jabatan || ''}</div>
                          </div>
                        </div>
                      </td>
                      <td style={{ padding: '12px 14px', textAlign: 'center', fontWeight: 700, fontSize: '0.95rem', color: '#2dce89' }}>
                        {d.point_jasa || 0}
                      </td>
                      <td style={{ padding: '12px 14px', textAlign: 'center', fontWeight: 700, fontSize: '0.95rem', color: d.point_absensi >= 0 ? '#11cdef' : '#f5365c' }}>
                        {d.point_absensi || 0}
                      </td>
                      <td style={{ padding: '12px 14px', textAlign: 'center' }}>
                        <span style={{
                          display: 'inline-flex', alignItems: 'center', gap: 4,
                          padding: '4px 14px', borderRadius: 20,
                          background: d.total_point > 5
                            ? '#d4edda' : d.total_point > 0
                            ? '#fff3cd' : '#f8d7da',
                          color: d.total_point > 5
                            ? '#155724' : d.total_point > 0
                            ? '#856404' : '#721c24',
                          fontWeight: 800, fontSize: '0.95rem',
                        }}>
                          {d.total_point > 0 ? <ArrowUp size={14} /> : d.total_point < 0 ? <ArrowDown size={14} /> : null}
                          {d.total_point || 0}
                        </span>
                      </td>
                      <td style={{ padding: '12px 14px', textAlign: 'right' }}>
                        <button
                          onClick={() => setDetailModal({ teknisi: d, tab: 'jasa' })}
                          className="btn-icon"
                          title="Lihat detail jasa & absensi"
                          style={{ color: '#4f46e5' }}
                        >
                          <Eye size={16} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Detail Modal */}
      {detailModal && (
        <div className="modal-overlay" onClick={() => setDetailModal(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 900, width: '95vw', background: '#fff', borderRadius: 16, boxShadow: '0 25px 60px rgba(0,0,0,0.25)' }}>
            <div className="modal-header">
              <h3>
                <Award size={18} style={{ marginRight: 8, verticalAlign: 'middle', color: '#f59e0b' }} />
                Detail {detailModal.teknisi.nama}
              </h3>
              <button className="btn btn-sm btn-outline" onClick={() => setDetailModal(null)}><X size={16} /></button>
            </div>
            <div className="modal-body" style={{ padding: 0, maxHeight: '80vh', overflow: 'auto' }}>
              {/* Tab navigation inside modal */}
              <div style={{ display: 'flex', borderBottom: '2px solid var(--gray-100)' }}>
                <button
                  onClick={() => setDetailModal({ ...detailModal, tab: 'jasa' })}
                  style={{
                    flex: 1, padding: '12px', border: 'none', cursor: 'pointer',
                    background: detailModal.tab === 'jasa' ? '#f0fdf4' : 'transparent',
                    fontWeight: detailModal.tab === 'jasa' ? 700 : 500,
                    color: detailModal.tab === 'jasa' ? '#2dce89' : 'var(--gray-500)',
                    borderBottom: detailModal.tab === 'jasa' ? '2px solid #2dce89' : '2px solid transparent',
                    marginBottom: -2, fontSize: '0.88rem', transition: 'all 0.15s',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                  }}
                >
                  <ArrowUp size={16} />
                  Detail Jasa ({detailModal.teknisi.detail_jasa?.length || 0})
                </button>
                <button
                  onClick={() => setDetailModal({ ...detailModal, tab: 'absensi' })}
                  style={{
                    flex: 1, padding: '12px', border: 'none', cursor: 'pointer',
                    background: detailModal.tab === 'absensi' ? '#f0f9ff' : 'transparent',
                    fontWeight: detailModal.tab === 'absensi' ? 700 : 500,
                    color: detailModal.tab === 'absensi' ? '#11cdef' : 'var(--gray-500)',
                    borderBottom: detailModal.tab === 'absensi' ? '2px solid #11cdef' : '2px solid transparent',
                    marginBottom: -2, fontSize: '0.88rem', transition: 'all 0.15s',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                  }}
                >
                  <Clock size={16} />
                  Detail Absensi ({detailModal.teknisi.detail_absensi?.length || 0})
                </button>
              </div>

              {/* Tab Content */}
              <div style={{ padding: '16px 20px', maxHeight: 550, overflowY: 'auto' }}>
                {detailModal.tab === 'jasa' ? (
                  <>
                    {(!detailModal.teknisi.detail_jasa || detailModal.teknisi.detail_jasa.length === 0) ? (
                      <div style={{ textAlign: 'center', padding: 32, color: 'var(--gray-400)', fontSize: '0.85rem' }}>
                        <Wrench size={32} style={{ marginBottom: 12, opacity: 0.3 }} />
                        <div>Tidak ada jasa yang dikerjakan periode ini</div>
                      </div>
                    ) : (
                      <table className="table" style={{ fontSize: '0.88rem', width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                          <tr style={{ background: '#f8f9fa', borderBottom: '2px solid var(--gray-100)' }}>
                            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: 'var(--gray-500)' }}>Nama Jasa</th>
                            <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)', width: 70 }}>Point</th>
                            <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)', width: 70 }}>Jumlah</th>
                            <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)', width: 90 }}>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailModal.teknisi.detail_jasa.map((j, idx) => (
                            <tr key={idx} style={{ borderBottom: '1px solid var(--gray-50)', background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                              <td style={{ padding: '10px 14px' }}>{j.nama}</td>
                              <td style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: '#2dce89' }}>{j.point}</td>
                              <td style={{ padding: '10px 14px', textAlign: 'center' }}>{j.jumlah}x</td>
                              <td style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 700, color: '#2dce89' }}>{j.subtotal}</td>
                            </tr>
                          ))}
                          <tr style={{ background: '#f0fdf4', fontWeight: 700 }}>
                            <td style={{ padding: '10px 14px', color: '#155724' }}>Total Point Jasa</td>
                            <td style={{ padding: '10px 14px', textAlign: 'center' }}></td>
                            <td style={{ padding: '10px 14px', textAlign: 'center' }}></td>
                            <td style={{ padding: '10px 14px', textAlign: 'center', color: '#155724', fontSize: '1rem' }}>
                              {detailModal.teknisi.detail_jasa.reduce((s, j) => s + (j.subtotal || 0), 0)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </>
                ) : (
                  <>
                    {(!detailModal.teknisi.detail_absensi || detailModal.teknisi.detail_absensi.length === 0) ? (
                      <div style={{ textAlign: 'center', padding: 32, color: 'var(--gray-400)', fontSize: '0.85rem' }}>
                        <Clock size={32} style={{ marginBottom: 12, opacity: 0.3 }} />
                        <div>Tidak ada absensi periode ini</div>
                      </div>
                    ) : (
                      <table className="table" style={{ fontSize: '0.88rem', width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                          <tr style={{ background: '#f8f9fa', borderBottom: '2px solid var(--gray-100)' }}>
                            <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: 'var(--gray-500)' }}>Tanggal</th>
                            <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)', width: 100 }}>Check In</th>
                            <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: 'var(--gray-500)', width: 80 }}>Point</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailModal.teknisi.detail_absensi.map((a, idx) => (
                            <tr key={idx} style={{ borderBottom: '1px solid var(--gray-50)', background: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                              <td style={{ padding: '10px 14px' }}>{a.tanggal}</td>
                              <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                                <span style={{
                                  fontWeight: 600,
                                  color: a.point >= 3 ? '#155724' : a.point >= 1 ? '#856404' : '#721c24',
                                }}>
                                  {a.check_in}
                                </span>
                              </td>
                              <td style={{
                                padding: '10px 14px', textAlign: 'center',
                                fontWeight: 700, fontSize: '1rem',
                                color: a.point >= 0 ? '#11cdef' : '#f5365c',
                              }}>
                                {a.point >= 0 ? `+${a.point}` : a.point}
                              </td>
                            </tr>
                          ))}
                          <tr style={{ background: '#f0f9ff', fontWeight: 700 }}>
                            <td style={{ padding: '10px 14px', color: '#0c5460' }}>Total Point Absensi</td>
                            <td style={{ padding: '10px 14px', textAlign: 'center' }}></td>
                            <td style={{ padding: '10px 14px', textAlign: 'center', color: '#0c5460', fontSize: '1rem' }}>
                              {detailModal.teknisi.detail_absensi.reduce((s, a) => s + (a.point || 0), 0)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer" style={{ justifyContent: 'flex-end', padding: '10px 16px' }}>
              <button className="btn btn-outline" onClick={() => setDetailModal(null)}>Tutup</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
